import EditorSimpleForm from './EditorSimpleForm'

export default EditorSimpleForm
